import {Component, Input} from '@angular/core';
import {roles, rolesLabelMap} from "../../../../constants/common.constants";
import {Router} from "@angular/router";
import {drillDownUrls} from "../../../../core/shared.selectors";
import {
  SetDrillDownUrls,
  TriggerNotificationRequest
} from "../../../../core/shared.actions";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {environment} from '../../../../../../../environments/environment';
import {
  NotificationTypeKeyMap
} from "../../../../constants/notification.config";

@Component({
  selector: 'app-participant-details',
  templateUrl: './participant-details.component.html',
  styleUrls: ['./participant-details.component.css']
})
export class ParticipantDetailsComponent {
  @Input() userDetails;
  @Input() loading;
  @Input() loggedInUserRole: number;

  protected readonly rolesLabelMap = rolesLabelMap;
  protected readonly roles = roles;

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
  ) {
  }

  ngOnInit() {
  }

  hippaConsentClicked(participant) {
    const url = `${environment.cdnBaseUrl}${participant.consentLink}`;
    window.open(url);
  }

  hippaAssentClicked(participant) {
    const url = `${environment.cdnBaseUrl}${participant.assentLink}`;
    window.open(url);
  }

  goToMember(id) {
    this.store.select(drillDownUrls).subscribe(data => {
      const updatedDrillDownUrls = [...data, this.router.url];
      if ([...data].pop() !== this.router.url) {
        this.store.dispatch(SetDrillDownUrls({payload: updatedDrillDownUrls}));
      }
    }).unsubscribe();


    const urlPrefix = this.router.url.split('/')[1];
    this.router.navigate([`${urlPrefix}/member/${id}/behavior-tracker`]);
  };

  triggerNotification(type: string, user) {
    this.store.dispatch(TriggerNotificationRequest({
      payload: {
        userId: user.id,
        type: NotificationTypeKeyMap[type]
      }
    }))
  }
}
